import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropDownStatusModule} from '../../A2-utils/drop-down-status/drop-down-status.module';
import {TripStatusChangeComponent} from './trip-status-change.component';
import {ReservationService} from '../reservations.service';
import { TextMaskModule } from 'angular2-text-mask';
import {ChangeStatusToCompleteModule} from '../change-status-to-complete/change-status-to-complete.module';
import { NextStatusSelectModule } from 'app/utils/next-status-select/next-status-select.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DropDownStatusModule,
        ReactiveFormsModule,
        TextMaskModule,
        ChangeStatusToCompleteModule,
        NextStatusSelectModule
    ],
  declarations: [
      TripStatusChangeComponent
  ],
    exports: [
        TripStatusChangeComponent
    ],
    providers: [
        ReservationService,
    ]
})
export class TripStatusChangeModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-status-change/trip-status-change.module.ts